var React = require('react');

function ShareIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-439.414 -1853.627)"},[React.createElement("path",{"d":"M4.315-.049,0,4.5,4.315,9.38","transform":"translate(449.457 1854.983) rotate(90)","fill":"none","stroke":"#64705e","strokeWidth":"2","key":0}),React.createElement("line",{"y2":"13","transform":"translate(444.84 1855.5)","fill":"none","stroke":"#64705e","strokeWidth":"2","key":1})]));
}

ShareIcon.defaultProps = {"width":"10.78","height":"14.873","viewBox":"0 0 10.78 14.873"};

module.exports = ShareIcon;

ShareIcon.default = ShareIcon;
